export default __webpack_public_path__ + "static/media/DNo.29-5.f54dd2ad.jpg";